export default __webpack_public_path__ + "static/media/incoming-pending.daa34a30.svg";